import { useMutation } from '@tanstack/react-query';

type Request = {
  companyId: number;
  chatCommentId: string;
};

export default function useDeleteCompanyChatComment() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId, chatCommentId }: Request) => {
      const response = await fetch(
        `/agent/api/companies/${companyId}/company_chat_comments/${chatCommentId}`,
        {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message || '削除に失敗しました');
      }

      return data;
    },
  });
}
